export default __webpack_public_path__ + "static/media/padelstore-logo.2df37ba6.svg";